import { engineActions as types } from '../actionTypes';

export const clearInstructionTimer = () => (dispatch, getState) => {
  const { instructionCountDownTimer } = getState().engine;
  if (instructionCountDownTimer) {
    clearInterval(instructionCountDownTimer);
  }
  dispatch({
    type: types.SET_TEST_DATA,
    payload: { instructionCountDownTimer: null },
  });
};

export const startInstructionTimer = (seconds, onComplete) => dispatch => {
  dispatch(clearInstructionTimer());

  if (seconds <= 0) {
    return;
  }

  let timeLeft = seconds;
  dispatch({
    type: types.TICK_INSTRUCTION_TIMER,
    payload: { instructionTimeLeft: timeLeft },
  });

  const intervalId = setInterval(() => {
    timeLeft -= 1;
    dispatch({
      type: types.TICK_INSTRUCTION_TIMER,
      payload: { instructionTimeLeft: timeLeft },
    });
    if (timeLeft <= 0) {
      clearInterval(intervalId);
      dispatch({
        type: types.SET_TEST_DATA,
        payload: { instructionCountDownTimer: null },
      });
      onComplete();
    }
  }, 1000);

  dispatch({
    type: types.SET_TEST_DATA,
    payload: { instructionCountDownTimer: intervalId },
  });
};
